import React from 'react';
import { Box, Icons, Text, useTheme } from '@ublend-npm/aulaui-core';
import pushRoute from '@app/utils/routing';
import { DARK } from '@core/constants/theme';

interface NavigationBackHeaderProps {
  wrapperStyle?: any;
  route: string;
}
// Common header with back button for navigation
const NavigationBackHeader: React.FC<NavigationBackHeaderProps> = ({
  wrapperStyle,
  route,
}) => {
  // Theme palette
  const { palette } = useTheme();
  const isDarkMode = palette?.mode === DARK;
  // Text color for each theme
  const textColor = isDarkMode ? palette.primary.light : palette.primary.dark;

  return (
    <Box sx={wrapperStyle}>
      <Box
        tabIndex={0}
        sx={{
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          gap: '8px',
          alignItems: 'center',
          marginLeft: '-4px',
          width: '70px',
        }}
        onClick={() => {
          pushRoute(route);
        }}
        aria-label="Back button, returns to previous page. To click this button, press Control-Option-Space"
      >
        <Icons.ArrowBack sx={{ color: textColor }} />
        <Text
          sx={{
            fontSize: '1rem',
            color: textColor,
            fontWeight: 500,
          }}
        >
          Back
        </Text>
      </Box>
    </Box>
  );
};

export default NavigationBackHeader;
